export default {
  path: '/login',
  name: 'Login',
  hidden: true,
  meta: {
    title: '登录'
  },
  component: () => import('@/views/login/Login.vue')
}
